import _ from 'lodash'
import * as THREE from 'three'

import Config from '@glass-designer/config'
import BaseObject from './baseObject'
import EditorTypes from '../types'


// Drag Shape
// A shape object in the scene to display a shape when dragging into the scene from the library
export default class DragShape extends BaseObject {
  constructor(editor, options = {}) {
    super(editor)

    this.position = new THREE.Vector2(0, 0, 0)

    this.dataGlassShapeList = []
    this.outlineGeom = null
    this.shapeObj = null

    this.sceneObject = new THREE.Object3D()
  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()

    if(this.shapeObj)
      this.shapeObj.position.set(this.position.x, this.position.y, 99)

  }


  // Update the position of the cutout
  setPosition(pos) {
    this.position.set(pos.x, pos.y)
  }


  /**
   * Build the shape info from a GlassShape object (or array of GlassShape objects) containing the segment data
   */
  buildFromGlassShape(glassShapeList) {
    let shapeDivisions = Config.Settings.arcSubdivisions

    this.clear()
    this.dataGlassShapeList = []
    if(_.isArray(glassShapeList))
      this.dataGlassShapeList = glassShapeList
    else
      this.dataGlassShapeList.push(glassShapeList)

    var vertices = []

    this.dataGlassShapeList.forEach(shape => {
      var shapePath = shape.generateShape()

      let shapePoints = shapePath.getPoints(shapeDivisions)
      for(var i = 0; i < shapePoints.length - 1; i++)
        vertices.push(shapePoints[i].x , shapePoints[i].y, 0, shapePoints[(i + 1) % shapePoints.length].x , shapePoints[(i + 1) % shapePoints.length].y, 0)

      // Add outline for the center cutout holes
      shape.getCenterCutoutList().forEach(centerCutout => {
        var centerCutPath = centerCutout.generateShape()

        let cutoutPoints = centerCutPath.getPoints(shapeDivisions)
        for(var i = 0; i < cutoutPoints.length - 1; i++)
          vertices.push(cutoutPoints[i].x , cutoutPoints[i].y, 0, cutoutPoints[(i + 1) % cutoutPoints.length].x , cutoutPoints[(i + 1) % cutoutPoints.length].y, 0)
      })
    })

    // Build the shape object from the hole shape data
    this.outlineGeom = new THREE.BufferGeometry()
    this.outlineGeom.setAttribute( 'position', new THREE.Float32BufferAttribute(vertices, 3))

    var outerMaterial = new THREE.LineBasicMaterial({
      color: this.editor.getTheme().dragObjectColour,
      transparent: true,
      opacity: this.editor.getTheme().dragObjectOpacity
    })
    this.shapeObj = new THREE.LineSegments(this.outlineGeom, outerMaterial)
    this.sceneObject.add(this.shapeObj)
  }


  clear() {
    if(this.shapeObj)
      this.sceneObject.remove(this.shapeObj)
    if(this.outlineGeom)
      this.outlineGeom.dispose()

    this.shapeObj = null
    this.outlineGeom = null
  }


}
